import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=28062513&scoped=true"
import script from "./infos.vue?vue&type=script&lang=js"
export * from "./infos.vue?vue&type=script&lang=js"
import style0 from "./infos.vue?vue&type=style&index=0&id=28062513&prod&lang=less"
import style1 from "./infos.vue?vue&type=style&index=1&id=28062513&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28062513",
  null
  
)

export default component.exports